export const CHART_SERIES_COLORS: string[] = [
  "#519DE9",
  "#7CC674",
  "#73C5C5",
  "#8481DD",
  "#F6D173",
  "#C46100",
  "#A30000",
  "#f79cc7",
  "#255716",
];

export function pickSeriesColor(index: number): string {
  return CHART_SERIES_COLORS[index % CHART_SERIES_COLORS.length];
}

export function resolveSeriesColor(
  color: string | string[] | undefined,
  fallbackIndex: number
): string {
  if (Array.isArray(color)) {
    const solid = color.find((c) => c && c !== "#dc2626");
    return solid || color[0] || pickSeriesColor(fallbackIndex);
  }
  return color || pickSeriesColor(fallbackIndex);
}
